import { Skeleton } from "antd";
import { useState } from "react";
import "./ImageWithSkeleton.css";

const ImageWithSkeleton = ({ src, alt, layout = "landscape" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`announcement-image-container ${layout}`}>
      {!loaded && (
        <Skeleton.Image
          active
          style={{ width: "100%", height: "100%" }}
          className="announcement-image-skeleton"
        />
      )}
      <img
        src={src}
        alt={alt}
        className="announcement-popup-image"
        style={loaded ? {} : { display: "none" }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default ImageWithSkeleton;
